module.exports = __webpack_public_path__ + "img/shareScripsWhite.0eca8082.svg";